import styled from "styled-components";
import { Checkbox, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";

export const MeetingTableContainer = styled.div`
    min-width: 100%;
`;

export const StyledTable = styled(Table)``;
export const StyledTableHead = styled(TableHead)``;
export const StyledTableBody = styled(TableBody)``;
export const StyledTableRow = styled(TableRow)``;
export const StyledTableCell = styled(TableCell)``;
export const StyledCheckbox = styled(Checkbox)``;